import React from 'react';
import styles from './Fireworks.css';
import fireworkBlue from './images/firework-blue.png';
import fireworkYellow from './images/firework-yellow.png';
import fireworkRed from './images/firework-red.png';
import fireworkOrange from './images/firework-orange.png';

const Fireworks = () => (
  <div className={styles.fireworks}>
    <div className={styles.fwLeft}>
      <div className={styles.fwYellowContainer}>
        <img src={fireworkYellow} className={styles.fwYellow} />
      </div>
      <div className={styles.fwBlueContainer}>
        <img src={fireworkBlue} className={styles.fwBlue} />
      </div>
    </div>

    <div className={styles.fwRight}>
      <div className={styles.fwRedContainer}>
        <img src={fireworkRed} className={styles.fwRed} />
      </div>
      <div className={styles.fwOrangeContainer}>
        <img src={fireworkOrange} className={styles.fwOrange} />
      </div>
    </div>
  </div>
);

export default Fireworks;
